import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import { map } from 'rxjs/internal/operators/map';
import * as i1 from '@angular/common/http';
import * as i3 from '@angular/forms';
import { Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/operators';
import { combineLatest } from 'rxjs';
import * as errorUtils from 'error-message-utility';
import * as i1$1 from 'reference-library';
import * as i4 from 'primeng/inputtext';
import * as i5 from '@angular/common';
import * as i6 from 'primeng/dropdown';
import * as i7 from 'primeng/api';
import * as i8 from 'primeng/inputmask';
import * as i9 from 'primeng/chips';
import { PrimengLibraryModule } from 'primeng-library';

class H1bJobDescriptionService {
    constructor(httpClient) {
        this.httpClient = httpClient;
    }
    getBeneficiaryEducationDetails(beneficiaryId, petitionId = null) {
        const slug = petitionId ? `?petitionId=${petitionId}` : '';
        return this.httpClient.get(`/beneficiary/${beneficiaryId}/education${slug}`).pipe(map((response) => {
            if (response.status) {
                return response.data;
            }
        }));
    }
}
H1bJobDescriptionService.ɵfac = function H1bJobDescriptionService_Factory(t) { return new (t || H1bJobDescriptionService)(i0.ɵɵinject(i1.HttpClient)); };
H1bJobDescriptionService.ɵprov = i0.ɵɵdefineInjectable({ token: H1bJobDescriptionService, factory: H1bJobDescriptionService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(H1bJobDescriptionService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: i1.HttpClient }]; }, null); })();

function H1bJobDescriptionLibraryComponent_div_6_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r7.getGlobalErrorMessages("REQUIRED"), " ");
} }
function H1bJobDescriptionLibraryComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, H1bJobDescriptionLibraryComponent_div_6_span_1_Template, 2, 1, "span", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r0.parentForm.controls["offerSignedByName"].errors == null ? null : ctx_r0.parentForm.controls["offerSignedByName"].errors.required);
} }
function H1bJobDescriptionLibraryComponent_div_11_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r8.getGlobalErrorMessages("REQUIRED"), " ");
} }
function H1bJobDescriptionLibraryComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, H1bJobDescriptionLibraryComponent_div_11_span_1_Template, 2, 1, "span", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r1.parentForm.controls["educationRequired"].errors == null ? null : ctx_r1.parentForm.controls["educationRequired"].errors.required);
} }
function H1bJobDescriptionLibraryComponent_ng_template_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 19);
    i0.ɵɵelementStart(1, "span");
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const group_r9 = ctx.$implicit;
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(group_r9 == null ? null : group_r9.label);
} }
function H1bJobDescriptionLibraryComponent_div_24_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r10 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r10.getGlobalErrorMessages("REQUIRED"), " ");
} }
function H1bJobDescriptionLibraryComponent_div_24_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, H1bJobDescriptionLibraryComponent_div_24_span_1_Template, 2, 1, "span", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r3.parentForm.controls["dotCode"].errors == null ? null : ctx_r3.parentForm.controls["dotCode"].errors.required);
} }
function H1bJobDescriptionLibraryComponent_div_31_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r11.getGlobalErrorMessages("REQUIRED"), " ");
} }
function H1bJobDescriptionLibraryComponent_div_31_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r12.getGlobalErrorMessages("NUMBER_ONLY"), " ");
} }
function H1bJobDescriptionLibraryComponent_div_31_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, H1bJobDescriptionLibraryComponent_div_31_span_1_Template, 2, 1, "span", 17);
    i0.ɵɵtemplate(2, H1bJobDescriptionLibraryComponent_div_31_span_2_Template, 2, 1, "span", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.parentForm.controls["experienceRequired"].errors == null ? null : ctx_r4.parentForm.controls["experienceRequired"].errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r4.parentForm.controls["experienceRequired"].errors == null ? null : ctx_r4.parentForm.controls["experienceRequired"].errors.pattern);
} }
function H1bJobDescriptionLibraryComponent_div_40_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r13.getGlobalErrorMessages("REQUIRED"), " ");
} }
function H1bJobDescriptionLibraryComponent_div_40_span_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r14.getGlobalErrorMessages("NUMBER_ONLY"), " ");
} }
function H1bJobDescriptionLibraryComponent_div_40_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, H1bJobDescriptionLibraryComponent_div_40_span_1_Template, 2, 1, "span", 17);
    i0.ɵɵtemplate(2, H1bJobDescriptionLibraryComponent_div_40_span_2_Template, 2, 1, "span", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.parentForm.controls["fieldOfStudy"].errors == null ? null : ctx_r5.parentForm.controls["fieldOfStudy"].errors.required);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r5.parentForm.controls["fieldOfStudy"].errors == null ? null : ctx_r5.parentForm.controls["fieldOfStudy"].errors.pattern);
} }
function H1bJobDescriptionLibraryComponent_div_49_span_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 18);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", ctx_r15.getGlobalErrorMessages("REQUIRED"), " ");
} }
function H1bJobDescriptionLibraryComponent_div_49_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, H1bJobDescriptionLibraryComponent_div_49_span_1_Template, 2, 1, "span", 17);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r6.parentForm.controls["technicalSkills"].errors == null ? null : ctx_r6.parentForm.controls["technicalSkills"].errors.required);
} }
class H1bJobDescriptionLibraryComponent {
    constructor(referenceLibraryService, apiService) {
        this.referenceLibraryService = referenceLibraryService;
        this.apiService = apiService;
        this.isWizard = false;
        this.observableSubscription$ = new Subject();
        this.groupedSpecializationList = [];
    }
    ngOnInit() {
        this.getEducationList();
        this.parentForm.get('offerSignedByName').setValidators(Validators.required);
        this.parentForm.get('educationRequired').setValidators(Validators.required);
        this.parentForm.get('dotCode').setValidators(Validators.required);
        this.parentForm.get('experienceRequired').setValidators([Validators.required, Validators.pattern('^[0-9]{1,2}$')]);
        this.parentForm.get('fieldOfStudy').setValidators(Validators.required);
        this.parentForm.get('technicalSkills').setValidators(Validators.required);
    }
    getEducationList() {
        const reqArray = [this.referenceLibraryService.getReferenceData('DEGR')];
        if (this.beneficiaryId) {
            const petId = (this.isWizard && this.petitionId) ? this.petitionId : null;
            reqArray.push(this.apiService.getBeneficiaryEducationDetails(this.beneficiaryId, petId));
        }
        combineLatest(reqArray)
            .pipe(takeUntil(this.observableSubscription$))
            .subscribe((response) => {
            this.educationList = response[0];
            if (response[1]) {
                this.benEducationDetails = response[1];
                this.updateSpecialization();
            }
        });
    }
    updateSpecialization() {
        // IM-21657 - Have delinked the field "Beneficiary’s highest degree (Field of study)" from the field of "What are the educational requirements for this job?"
        if (this.benEducationDetails) {
            this.groupedSpecializationList = [];
            Object.values(this.benEducationDetails).forEach((el, index) => {
                const newEl = { label: Object.keys(this.benEducationDetails)[index], value: Object.keys(this.benEducationDetails)[index], items: el };
                this.groupedSpecializationList.push(newEl);
            });
        }
    }
    getGlobalErrorMessages(error) {
        return errorUtils.errorMessages.get(error);
    }
    ngOnDestroy() {
        this.observableSubscription$.next();
        this.observableSubscription$.complete();
    }
}
H1bJobDescriptionLibraryComponent.ɵfac = function H1bJobDescriptionLibraryComponent_Factory(t) { return new (t || H1bJobDescriptionLibraryComponent)(i0.ɵɵdirectiveInject(i1$1.ReferenceLibraryService), i0.ɵɵdirectiveInject(H1bJobDescriptionService)); };
H1bJobDescriptionLibraryComponent.ɵcmp = i0.ɵɵdefineComponent({ type: H1bJobDescriptionLibraryComponent, selectors: [["lib-h1b-job-description"]], inputs: { disabledControls: "disabledControls", parentForm: "parentForm", beneficiaryId: "beneficiaryId", isWizard: "isWizard", petitionId: "petitionId" }, decls: 50, vars: 19, consts: [[3, "formGroup"], [1, "row", "mb-3"], [1, "col-md-4", "form-group", "input-disabled"], [1, "label-cls", "required"], ["id", "offerSignedByName", "formControlName", "offerSignedByName", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mask-in", "mw-100", 3, "readonly"], [4, "ngIf"], [1, "col-md-4", "processing-dropdown"], ["id", "educationRequired", "appendTo", "body", "formControlName", "educationRequired", "optionLabel", "name", "optionValue", "code", "placeholder", "select", 3, "options", "filter", "disabled"], [1, "label-cls"], ["id", "specializationList", "appendTo", "body", "formControlName", "selectedEducationId", "optionLabel", "fieldOfStudy", "optionValue", "id", "placeholder", "select", 3, "options", "disabled", "group"], ["pTemplate", "group"], ["slotChar", "", "mask", "999", "id", "dotCode", "formControlName", "dotCode", 3, "readonly"], ["id", "experienceRequired", "formControlName", "experienceRequired", "type", "text", "pInputText", "", "placeholder", "Enter", 1, "im-input", "mask-in", "mw-100", 3, "readonly"], [1, "col-md-12", "form-group", "input-disabled"], [1, "p-fluid"], ["separator", ",", "formControlName", "fieldOfStudy", "addOnTab", "true", "addOnBlur", "true", 3, "disabled"], ["separator", ",", "formControlName", "technicalSkills", "addOnTab", "true", "addOnBlur", "true", 3, "disabled"], ["class", "invalid-message", 4, "ngIf"], [1, "invalid-message"], [1, "p-d-flex", "p-ai-center"]], template: function H1bJobDescriptionLibraryComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "label", 3);
        i0.ɵɵtext(4, " Who has signed the offer letter? (Name of person)");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(5, "input", 4);
        i0.ɵɵtemplate(6, H1bJobDescriptionLibraryComponent_div_6_Template, 2, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "div", 6);
        i0.ɵɵelementStart(8, "label", 3);
        i0.ɵɵtext(9, " What are the educational requirements for this job?");
        i0.ɵɵelementEnd();
        i0.ɵɵelement(10, "p-dropdown", 7);
        i0.ɵɵtemplate(11, H1bJobDescriptionLibraryComponent_div_11_Template, 2, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(12, "div", 6);
        i0.ɵɵelementStart(13, "label", 8);
        i0.ɵɵtext(14, "Beneficiary\u2019s highest degree (Field of study)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(15, "p-dropdown", 9);
        i0.ɵɵtemplate(16, H1bJobDescriptionLibraryComponent_ng_template_16_Template, 3, 1, "ng-template", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(17, "div", 1);
        i0.ɵɵelementStart(18, "div", 2);
        i0.ɵɵelementStart(19, "label", 3);
        i0.ɵɵtext(20);
        i0.ɵɵelementStart(21, "span");
        i0.ɵɵtext(22, "(Dictionary of occupational titles)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(23, "p-inputMask", 11);
        i0.ɵɵtemplate(24, H1bJobDescriptionLibraryComponent_div_24_Template, 2, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(25, "div", 2);
        i0.ɵɵelementStart(26, "label", 3);
        i0.ɵɵtext(27, " Experience Required ");
        i0.ɵɵelementStart(28, "span");
        i0.ɵɵtext(29, "(In years)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(30, "input", 12);
        i0.ɵɵtemplate(31, H1bJobDescriptionLibraryComponent_div_31_Template, 3, 2, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "div", 1);
        i0.ɵɵelementStart(33, "div", 13);
        i0.ɵɵelementStart(34, "label", 3);
        i0.ɵɵtext(35, " What will be the required field of study for this position? ");
        i0.ɵɵelementStart(36, "span");
        i0.ɵɵtext(37, "(Please enter comma separated values)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(38, "div", 14);
        i0.ɵɵelement(39, "p-chips", 15);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(40, H1bJobDescriptionLibraryComponent_div_40_Template, 3, 2, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(41, "div", 1);
        i0.ɵɵelementStart(42, "div", 13);
        i0.ɵɵelementStart(43, "label", 3);
        i0.ɵɵtext(44, " Enter technical skills required for this position? ");
        i0.ɵɵelementStart(45, "span");
        i0.ɵɵtext(46, "(Please enter comma separated values)");
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(47, "div", 14);
        i0.ɵɵelement(48, "p-chips", 16);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(49, H1bJobDescriptionLibraryComponent_div_49_Template, 2, 1, "div", 5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵproperty("formGroup", ctx.parentForm);
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("readonly", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.parentForm.controls["offerSignedByName"].touched && ctx.parentForm.controls["offerSignedByName"].invalid);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.educationList)("filter", false)("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.parentForm.controls["educationRequired"].touched && ctx.parentForm.controls["educationRequired"].invalid);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("options", ctx.groupedSpecializationList)("disabled", ctx.disabledControls)("group", true);
        i0.ɵɵadvance(5);
        i0.ɵɵtextInterpolate1(" Dot Code ", ctx.parentForm.controls["dotCode"].errors == null ? null : ctx.parentForm.controls["dotCode"].errors.pattern, "");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("readonly", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.parentForm.controls["dotCode"].touched && ctx.parentForm.controls["dotCode"].invalid);
        i0.ɵɵadvance(6);
        i0.ɵɵproperty("readonly", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.parentForm.controls["experienceRequired"].touched && ctx.parentForm.controls["experienceRequired"].invalid);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.parentForm.controls["fieldOfStudy"].touched && ctx.parentForm.controls["fieldOfStudy"].invalid);
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("disabled", ctx.disabledControls);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.parentForm.controls["technicalSkills"].touched && ctx.parentForm.controls["technicalSkills"].invalid);
    } }, directives: [i3.NgControlStatusGroup, i3.FormGroupDirective, i3.DefaultValueAccessor, i3.NgControlStatus, i3.FormControlName, i4.InputText, i5.NgIf, i6.Dropdown, i7.PrimeTemplate, i8.InputMask, i9.Chips], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(H1bJobDescriptionLibraryComponent, [{
        type: Component,
        args: [{
                selector: 'lib-h1b-job-description',
                templateUrl: 'h1b-job-description.component.html',
                styles: []
            }]
    }], function () { return [{ type: i1$1.ReferenceLibraryService }, { type: H1bJobDescriptionService }]; }, { disabledControls: [{
            type: Input
        }], parentForm: [{
            type: Input
        }], beneficiaryId: [{
            type: Input
        }], isWizard: [{
            type: Input
        }], petitionId: [{
            type: Input
        }] }); })();

class H1bJobDescriptionModule {
}
H1bJobDescriptionModule.ɵfac = function H1bJobDescriptionModule_Factory(t) { return new (t || H1bJobDescriptionModule)(); };
H1bJobDescriptionModule.ɵmod = i0.ɵɵdefineNgModule({ type: H1bJobDescriptionModule });
H1bJobDescriptionModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[
            PrimengLibraryModule,
            FormsModule,
            ReactiveFormsModule
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(H1bJobDescriptionModule, { declarations: [H1bJobDescriptionLibraryComponent], imports: [PrimengLibraryModule,
        FormsModule,
        ReactiveFormsModule], exports: [H1bJobDescriptionLibraryComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(H1bJobDescriptionModule, [{
        type: NgModule,
        args: [{
                declarations: [H1bJobDescriptionLibraryComponent],
                imports: [
                    PrimengLibraryModule,
                    FormsModule,
                    ReactiveFormsModule
                ],
                exports: [H1bJobDescriptionLibraryComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of h1b-job-description
 */

/**
 * Generated bundle index. Do not edit.
 */

export { H1bJobDescriptionLibraryComponent, H1bJobDescriptionModule, H1bJobDescriptionService };
//# sourceMappingURL=h1b-job-description.js.map
